import React, { useContext } from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import { CartContext } from "./CartContext";

function Shop() {
  const { addToCart } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleAddToCart = (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product.id, 1, product.size[0] || "One Size", product.colors[0] || "Default");
  };

  const renderStars = (rating) => {
    const stars = [];
    const rate = parseFloat(rating);
    for (let i = 1; i <= 5; i++) {
      if (i <= rate) {
        stars.push(<span key={i} className="star filled">★</span>);
      } else {
        stars.push(<span key={i} className="star empty">☆</span>);
      }
    }
    return stars;
  };

  return (
    <div className="shop main">
      <div className="shop-container">
        <div className="products-grid">
          {productData.map((product) => (
            <Link
              to={`/product/${product.id}`}
              key={product.id}
              className="product-card1"
              onClick={toTop}
            >
              <div className="product-image-container">
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
                <button 
                  className="cart-icon-btn"
                  onClick={(e) => handleAddToCart(e, product)}
                >
                  <span className="cart-icon">🛒</span>
                  <span className="add-to-cart-text">Add to Cart</span>
                </button>
              </div>
              <div className="product-info">
                <div className="product-brand">{product.brand}</div>
                <h3 className="product-name">{product.name}</h3>
                {product.reviews && product.reviews !== "0" && (
                  <div className="product-rating">
                    {renderStars(product.rating)}
                    <span className="reviews-count">
                      ({product.reviews} Reviews)
                    </span>
                  </div>
                )}
                <div className="product-price">
                  {product.originalPrice &&
                    product.originalPrice !== product.price && (
                      <span className="original-price">
                        ${product.originalPrice} USD
                      </span>
                    )}
                  <span className="current-price">${product.price} USD</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Shop;
